import type {
  CoverageGapClosingReason,
  CoverageGapSort,
  UncoveredClaimSort,
} from "@shared/types/corpus/api.ts";

/** What each ranking of the coverage gaps is called. */
export const COVERAGE_GAP_SORT_LABELS: Record<CoverageGapSort, string> = {
  askers: "People who asked",
  claims: "Claims",
  last_asked: "Most recent ask",
};

/** What each ranking of the uncovered claims in no gap is called. */
export const UNCOVERED_CLAIM_SORT_LABELS: Record<UncoveredClaimSort, string> = {
  last_asked: "Most recent ask",
  askers: "People who asked",
  asked: "Times asked",
};

/** What each reason for closing a coverage gap is called. */
export const COVERAGE_GAP_REASON_LABELS: Record<CoverageGapClosingReason, string> = {
  filled: "Filled: the corpus now answers it",
  no_research: "No research exists to answer it",
  dismissed: "Dismissed: not worth pursuing",
};

/** What each reason for closing a coverage gap is called in a few words. */
export const COVERAGE_GAP_REASON_NAMES: Record<CoverageGapClosingReason, string> = {
  filled: "Filled",
  no_research: "No research exists",
  dismissed: "Dismissed",
};
